export const ROOT_HIERARCHY_ID = 0;
export const HIERARCHY_INITIAL_DEPTH = 2;
export const HIERARCHY_DEFAULT_DEPTH = 3;
export const HIERARCHY_MAX_DEPTH = 9999;
